<template>
    <div class="total-presence">
        <Card class="p-m-3" :class="{'card-loading': isLoading}">
            <template #title>
                <div style="height: .5em;  margin: -0.5em;">
                    <ProgressBar
                            class="p-m-0 p-p-0"
                            v-if="isLoading"
                            mode="indeterminate"
                            style="height: .5em"
                    />
                </div>
                <h2>סיכום נוכחות </h2>
            </template>
            <template #content>
                <h3 class="no-content" v-if="!isLoading && getPresenceStatus.length === 0">אין נתונים להצגה</h3>
                <div class="p-grid">
                    <div
                            class="p-col-12 p-sm-12 p-md-6 p-lg-6"
                            @click="moveToData(status)"
                            v-for="status in getPresenceStatus"
                            :key="status.id">
                        <div
                                v-tooltip.top="'לחץ לצפיה בדיווחי הנוכחות'"
                                class="p-p-3  p-card item" :style="{'background-color': status.color}">
                            <h1 style="text-align: center">
                                {{ getPresenceTotal(status) }}
                            </h1>
                            <h2 style="text-align: center">
                                {{ status.hebrewName }}
                            </h2>
                        </div>
                    </div>
                </div>

            </template>
        </Card>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Service from "@/service/Service";

export default {
    service: null,

    name: "total-presence-card",
    props: {pupil: Object, startDate: Number, endDate: Number},
    components: {},
    data() {
        return {
            isLoading: false,
            totalPresence: null,
        };
    },
    created() {
    },
    mounted() {
        this.service = new Service();
        if (this.pupil) {
            this.getTotalPresence();
        }
    },
    methods: {
        moveToData(status) {
            const routeData = this.$router.resolve({
                name: 'presence',
                query: {
                    pupil: this.pupil.id,
                    status: status.id,
                    start: this.startDate,
                    end: this.endDate,
                }
            })
            window.open(routeData.href, '_blank');
        },
            getPresenceTotal(status) {
            if (this.totalPresence) {
                return this.totalPresence?.find((p) => p.id === status.id)?.total || 0;
            } else {
                return '---'
            }
        },
        getTotalPresence() {
            this.isLoading = true
            this.service
                .getTotalPresencePupil(this.pupil.id, this.startDate, this.endDate)
                .then((data) => {
                    data?.map((e) => (e.status = this.getStatusObj(e.id)));
                    data?.sort((a, b) => (a.status?.sort > b.status?.sort ? 1 : -1));
                    this.totalPresence = data;
                    this.isLoading = false
                });
        },
        getStatusObj(statusId) {
            return this?.presenceStatus?.find(
                (presenceStatus) => presenceStatus.id === statusId
            );
        },
    },
    computed: {
        getPresenceStatus() {
            return this?.presenceStatus?.filter(p => p.showStatics && this.getPresenceTotal(p) > 0)
        },
        ...mapState(["presenceStatus"]),
    },
    watch: {
        pupil() {
            this.isLoading = true
            this.getTotalPresence();
        },
        startDate() {
            this.isLoading = true
            this.getTotalPresence();
        },
        endDate() {
            this.isLoading = true
            this.getTotalPresence();
        },
    },
};
</script>

<style scoped>
.item{
    cursor: context-menu;
}
.no-content {
    text-align: center;
    color: #999999;
}
</style>
